module.exports = __webpack_public_path__ + "static/detailing-services-list-de9959f337c63a9f2e2ab3543035736a.jpg";